import React from 'react'

import { Upload, Button,  } from 'antd';
import { UploadOutlined } from '@ant-design/icons';


const FileBox = ({label}) => {
  const props = {
    name: 'file',
    action: 'https://pogamer.in.ngrok.io/sailor/v1/order-management/file/upload',
    headers: {
      authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    listType: 'picture',
    beforeUpload(file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const img = document.createElement('img');
          img.src = reader.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            ctx.fillStyle = 'red';
            ctx.textBaseline = 'middle';
            ctx.font = '33px Arial';
            canvas.toBlob(resolve);
          };
        };
      });
    },
    onRemove: file => {
      alert('oo')
    },
  };
  return ( 
    
      <Upload {...props}>
        
        <Button icon={<UploadOutlined />} style={{width: '100%', display: 'flex', justifyContent: 'center'}}>{label}</Button>
      </Upload>

   );
}
 
export default FileBox;